<template>
  <div id="page-joint-partner">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="regionId" label="Region" required>
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" required />
        </el-form-item>
        <el-form-item label="时间段" required>
          <filter-date-range :value.sync="dateRange" :range="90" :init-range="7" required />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" :loading="isLoading" @click="getDataList">查询</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-table stripe size="small" :data="dataList" v-loading="isLoading">
      <el-table-column prop="reportDate" label="日期" width="100"></el-table-column>
      <el-table-column prop="cityName" label="城市" width="120"></el-table-column>
      <el-table-column prop="trips" label="有效订单">
        <template slot-scope="scope">
          {{ scope.row.trips | toThousands() }}
        </template>
      </el-table-column>
      <el-table-column label="运营车">
        <el-table-column prop="totalOperationBikeNum" label="总运营车">
          <template slot-scope="scope">
            {{ scope.row.totalOperationBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="realHealthyBikeNum" label="健康车">
          <template slot-scope="scope">
            {{ scope.row.realHealthyBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="outopsBikeNum" label="运营区外健康车">
          <template slot-scope="scope">
            {{ scope.row.outopsBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="healthyRate" label="健康度"></el-table-column>
        <el-table-column prop="unRideBikeNum" label="未骑行">
          <template slot-scope="scope">
            {{ scope.row.unRideBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="unReportBikeNum" label="未上报">
          <template slot-scope="scope">
            {{ scope.row.unReportBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="unReportBikeNumToday" label="未上报(日新增)">
          <template slot-scope="scope">
            {{ scope.row.unReportBikeNumToday | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="pendingInshopBikeNum" label="待入库">
          <template slot-scope="scope">
            {{ scope.row.pendingInshopBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="inshopBikeNum" label="入库维修">
          <template slot-scope="scope">
            {{ scope.row.inshopBikeNum | toThousands() }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="非运营车">
        <el-table-column prop="sleepingBikeNum" label="休眠车">
          <template slot-scope="scope">
            {{ scope.row.sleepingBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="stolenBikeNum" label="丢失车">
          <template slot-scope="scope">
            {{ scope.row.stolenBikeNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="detainBikeNum" label="扣车">
          <template slot-scope="scope">
            {{ scope.row.detainBikeNum | toThousands() }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="周转">
        <el-table-column prop="dab" label="DAB">
          <template slot-scope="scope">
            {{ scope.row.dab | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="dabProportion" label="DAB占比"></el-table-column>
        <el-table-column prop="dabTurnoverRate" label="DAB周转率"></el-table-column>
        <el-table-column prop="totalTurnoverRate" label="总运营周转"></el-table-column>
        <el-table-column prop="wab" label="WAB">
          <template slot-scope="scope">
            {{ scope.row.wab | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="wabProportion" label="WAB占比"></el-table-column>
      </el-table-column>
      <el-table-column label="运维">
        <el-table-column prop="replaceBatteryNum" label="换电量">
          <template slot-scope="scope">
            {{ scope.row.replaceBatteryNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="fetchNum" label="寻回量">
          <template slot-scope="scope">
            {{ scope.row.fetchNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="fetchUserNum" label="寻回出勤人数">
          <template slot-scope="scope">
            {{ scope.row.fetchUserNum | toThousands() }}
          </template>
        </el-table-column>
        <el-table-column prop="replaceBatteryUserNum" label="换电出勤人数">
          <template slot-scope="scope">
            {{ scope.row.replaceBatteryUserNum | toThousands() }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { toThousands, dateFormat } from '@/utils'

export default {
  data() {
    return {
      dataList: [],
      isLoading: false,
      dateRange: [],
      searchForm: {
        startDate: '',
        endDate: '',
        regionId: '',
        partnerType: 1,
      },
    }
  },
  filters: {
    toThousands: function (num) {
      return toThousands(num)
    },
  },
  methods: {
    // 获取列表数据
    getDataList() {
      const params = {
        ...this.searchForm,
      }
      if (this.dateRange) {
        params.endDate = dateFormat(this.dateRange[1])
        params.startDate = dateFormat(this.dateRange[0])
      }
      this.isLoading = true
      this.fetch
        .get('partnerDataList', { params })
        .then((res) => {
          this.dataList = (res.data && res.data.apolloSpockReportModels) || []
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
